import { ProjectHttpClient } from './httpClient';

const serviceUrl = (projectId, featureName) =>
  `projects/${projectId}/userFeatureEnabled?featureName=${featureName}`;

export const getUserFeatureEnabled = async (projectId, featureName) => {
  const result = await ProjectHttpClient.get(
    serviceUrl(projectId, featureName)
  );
  return result.data;
};

export const saveUserFeatureEnabled = async (
  projectId,
  featureName,
  enabled
) => {
  const result = await ProjectHttpClient.post(
    serviceUrl(projectId, featureName),
    { enabled }
  );
  return result.data;
};
